import { create } from 'zustand';
import { useRightSidebar } from './RightSidebar';
import { useFormPanel } from './formPanelStore';

/**
 * Hosts the event "Design Journey" live preview in the right rail.
 *
 * Mirrors `formPanelStore`: when the Design Journey tab mounts it `open()`s the
 * rail (remembering its prior state) and exposes a `slotEl` — a DOM node the
 * rail renders. `SurveyConfigSection` then React-portals the live preview into
 * that node, so the preview keeps receiving the editor's in-progress `draft`
 * (live colours, selected step) while visually living in the docked sidebar.
 * Leaving the tab `close()`s it and restores the rail to its previous state.
 *
 * A portal (not a remount via props) is deliberate: the preview must reflect
 * unsaved edits, which only works while it stays in the editor's React tree.
 */
interface JourneyPreviewState {
  active: boolean;
  /** Portal target rendered by RightSidebar; null while collapsed/closed. */
  slotEl: HTMLElement | null;
  _prevOpen: boolean;
  open: () => void;
  close: () => void;
  setSlot: (el: HTMLElement | null) => void;
}

export const useJourneyPreview = create<JourneyPreviewState>((set, get) => ({
  active: false,
  slotEl: null,
  _prevOpen: false,
  open: () => {
    /*
     * El carril hospeda UNA cosa, y aquí manda el Journey.
     *
     * `formPanelStore.active` es global y no se entera de que has navegado: si
     * venías de darle a «editar evento», el formulario seguía puesto, y en
     * `RightSidebar` el formulario gana al Journey. Resultado medido: entrar
     * en Design Journey y encontrarse las propiedades del EVENTO, con las de
     * diseño en ninguna parte — porque su portal ni siquiera llega a montarse.
     *
     * Se cierra ANTES de recordar el estado del carril: así `_prevOpen` guarda
     * cómo estaba de verdad, no cómo lo dejó el formulario al irse.
     */
    useFormPanel.getState().closeForm();
    const right = useRightSidebar.getState();
    set({ active: true, _prevOpen: right.open });
    right.setOpen(true);
  },
  close: () => {
    const prev = get()._prevOpen;
    set({ active: false, slotEl: null });
    useRightSidebar.getState().setOpen(prev);
  },
  setSlot: (slotEl) => set({ slotEl }),
}));
